import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { assessmentAndAuditsBaseUrl, assessmentAndAudits } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const companyService = createApi({
  reducerPath: "companyService",
  baseQuery: fetchBaseQuery({ baseUrl: assessmentAndAuditsBaseUrl }),
  tagTypes: ["Company"],
  endpoints: (builder) => ({
    getAllCompanies: builder.mutation({
      query(body) {
        return {
          url: `${assessmentAndAudits.getAllCompany}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useGetAllCompaniesMutation,
} = companyService;